import { CommonModule } from '@angular/common';
import { Injector, NgModule } from '@angular/core';
import { CloudTwinSharedModule } from '@cloud-twin-v2/cloud-twin-shared/cloud-twin-shared.module';
import { CommonFiltersModule } from '@common-modules/common-filters/common-filters.module';
import { DynamicLayoutModule } from '@common-modules/dynamic-layout/dynamic-layout.module';
import { CommonSharedComponentModule } from '@common-modules/shared-component/common-shared-component.module';
import { CommonSharedModule } from '@common-modules/shared/common-shared.module';
import { RolesService } from '@common-modules/shared/roles/roles.service';
import { WidgetRegistryService } from '@common-modules/widget-registry/widget-registry';
import { GenericChartsModule } from '@common-modules/wlm-charts/generic-charts.module';
import { WLMGridModule } from '@common-modules/wlm-grid/wlm-grid.module';
import { SecurityExternalSettings } from '@common-modules/wlm-security/security-external-settings';
import { WlmSecurityModule } from '@common-modules/wlm-security/wlm-security.module';
import { TranslateModule } from '@ngx-translate/core';
import { CtSecurityRoutingModule } from './ct-security-routing.module';
import { GroupsPageComponent2 } from './groups-page/groups-page.component';
import { ModelsSecurityWidgetComponent } from './models-security/models-security-widget.component';
import { GroupModelsService } from './services/group-models.service';
import { UsersService } from './services/users.service';

const externalSettings: SecurityExternalSettings = {
  hideActivityButton: true,
  debug: true,
  pages: {
    groupsPage: {
      rightPanel: {
        widgets: [
          {
            component: ModelsSecurityWidgetComponent,
            labelKey: 'ModelsSecurityWidgetComponent',
          },
        ],
      },
    },
  },
};

@NgModule({
  declarations: [GroupsPageComponent2, ModelsSecurityWidgetComponent],
  imports: [
    CtSecurityRoutingModule,
    CommonModule,
    CommonSharedModule,
    CommonSharedComponentModule,
    CloudTwinSharedModule,
    WLMGridModule,
    TranslateModule,
    GenericChartsModule,
    CommonFiltersModule,
    DynamicLayoutModule,
    WlmSecurityModule.forFeature(externalSettings),
  ],
  exports: [GroupsPageComponent2],
  providers: [
    RolesService,
    { provide: 'RolesService', useExisting: RolesService },
    GroupModelsService,
    { provide: 'GroupModelsService', useExisting: GroupModelsService },
    UsersService,
    { provide: 'UsersService', useExisting: UsersService },
  ],
})
export class CtSecurityModule {
  static injector: Injector;
  constructor(injector: Injector, widgetRegistry: WidgetRegistryService) {
    CtSecurityModule.injector = injector;
    widgetRegistry.register([
      {
        name: 'ModelsSecurityWidgetComponent',
        widgetClass: ModelsSecurityWidgetComponent,
      },
    ]);
  }
}
